import type { ResolvedFilter } from './filter';

export function mergeLockedFilters(
    filters: ResolvedFilter[],
    locked: ResolvedFilter[],
): ResolvedFilter[] {
    if (locked.length === 0) return filters;
    const lockedKeys = new Set(locked.map((f) => f.key));
    return [...filters.filter((f) => !lockedKeys.has(f.key)), ...locked];
}

export function storableFilters(
    requested: ResolvedFilter[] | undefined,
    fallback: ResolvedFilter[],
): ResolvedFilter[] {
    return (requested ?? fallback).filter((f) => !f.locked);
}
